import { entities } from "sbtech-sports-data-api-client";
import { MasterEvent, LiveGameState, MasterEventInitialData } from "../../data";
import { getCurrentTime } from "sb-resp-utils";
import { TeamScoreParser } from "../TeamScoreParser";
import { ScoreboardParser } from "../ScoreboardParser";
import { DateFromISO } from "sb-js-extends";
DateFromISO();
export class MasterEventParser {
    constructor() {
        this.liveTimeCalculatorByClockDirection = {
            [entities.ClockDirection.Timer]: (gameTime, interval) => gameTime - interval,
            [entities.ClockDirection.Stopwatch]: (gameTime, interval) => gameTime + interval
        };
    }
    static get instance() {
        if (!MasterEventParser._instance) {
            MasterEventParser._instance = new MasterEventParser();
        }
        return MasterEventParser._instance;
    }
    parse(sportEvent, existingEvent, uiPreferences) {
        if (existingEvent) {
            return this.parseUpdate(sportEvent, existingEvent);
        }
        let initialParseEvent = this.parseInitial(sportEvent, uiPreferences);
        return this.parseUpdate(sportEvent, initialParseEvent);
    }
    parseInitial(sportEvent, uiPreferences) {
        let teamNames = this.parseTeamNames(sportEvent);
        let dateTime = this.parseDateTime(sportEvent, uiPreferences);
        let masterEvent = new MasterEventInitialData({
            eventName: sportEvent.eventName ? sportEvent.eventName : "",
            sportName: sportEvent.sportName,
            sportID: sportEvent.sportId,
            id: sportEvent.id,
            team1Name: teamNames.Home,
            team2Name: teamNames.Away,
            leagueID: sportEvent.leagueId,
            leagueName: sportEvent.leagueName,
            eventDate: dateTime.Date,
            eventTime: dateTime.Time,
            isTeamSwapEnabled: sportEvent.isTeamSwap,
            eventDateTime: sportEvent.startEventDate,
            regionId: sportEvent.regionId,
            betslipLine: sportEvent.betslipLine
        });
        return masterEvent;
    }
    parseUpdate(sportEvent, existingEvent) {
        let teamScores = TeamScoreParser.instance.parse(sportEvent, existingEvent);
        let liveGameState = this.parseLiveGameState(sportEvent);
        let liveStartCountdown = this.parseLiveStartCountdown(existingEvent.eventDateTime);
        let scoreboard = ScoreboardParser.instance.parse(sportEvent, existingEvent.sportID, existingEvent.isTeamSwapEnabled);
        let masterEvent = new MasterEvent(Object.assign(Object.assign({}, existingEvent), { score1: teamScores.Home, score2: teamScores.Away, isLive: sportEvent.isLive, markets: [], liveGameState,
            liveStartCountdown,
            scoreboard, status: sportEvent.status }));
        return masterEvent;
    }
    parseLiveGameState(sportEvent) {
        if (!sportEvent.liveGameState) {
            return undefined;
        }
        return new LiveGameState(Object.assign(Object.assign({}, sportEvent.liveGameState), { gameTime: sportEvent.liveGameState.gameTime !== null && sportEvent.liveGameState.gameTime >= 0 ?
                sportEvent.liveGameState.gameTime * 1000 : -1 }));
    }
    parseLiveStartCountdown(eventDateTime) {
        let eventStartingDate = Date.fromISO(eventDateTime);
        if (!eventStartingDate) {
            return 0;
        }
        let delta = eventStartingDate.getTime() - (window["serverdate"] || new Date()).getTime();
        return (delta < 0) ? 0 : delta;
    }
    parseTeamNames(sportEvent) {
        if (!sportEvent.participants || !sportEvent.participants[0] || !sportEvent.participants[1]) {
            return { Home: "", Away: "" };
        }
        if (sportEvent.participants[0].venueRole && sportEvent.participants[1].venueRole) {
            return this.parseTeamNamesByVenue(sportEvent);
        }
        return this.parseTeamNamesByIndex(sportEvent);
    }
    parseTeamNamesByIndex(sportEvent) {
        return sportEvent.isTeamSwap
            ? { Home: sportEvent.participants[1].name, Away: sportEvent.participants[0].name }
            : { Home: sportEvent.participants[0].name, Away: sportEvent.participants[1].name };
    }
    parseTeamNamesByVenue(sportEvent) {
        let homeParticipant = sportEvent.participants.find((par) => par.venueRole === "Home");
        let awayParticipant = sportEvent.participants.find((par) => par.venueRole === "Away");
        return sportEvent.isTeamSwap
            ? { Home: awayParticipant ? awayParticipant.name : "", Away: homeParticipant ? homeParticipant.name : "" }
            : { Home: homeParticipant ? homeParticipant.name : "", Away: awayParticipant ? awayParticipant.name : "" };
    }
    parseDateTime(sportEvent, uiPreferences) {
        let datetime = this.getFormattedDateTime(sportEvent.startEventDate, uiPreferences.timeZone, uiPreferences.dateFormat, uiPreferences.timeFormat);
        return {
            Date: datetime.Date,
            Time: datetime.Time
        };
    }
    getFormattedDateTime(date, timeZone, dateFormat, timeFormat) {
        let convertedDate = Date.fromISO(date);
        if (convertedDate === undefined) {
            throw "invalid argument";
        }
        let currentDate = getCurrentTime(convertedDate, timeZone);
        let formattedDate = currentDate.toStringEx(dateFormat);
        let formattedTime = currentDate.formatDate(timeFormat);
        return {
            Date: formattedDate,
            Time: formattedTime
        };
    }
    getLiveGameStateTime(liveGameState, newInterval) {
        if (!liveGameState || !liveGameState.gameTime) {
            return -1;
        }
        if (!liveGameState.clockRunning) {
            return liveGameState.gameTime;
        }
        return this.liveTimeCalculatorByClockDirection[liveGameState.clockDirection](liveGameState.gameTime, newInterval);
    }
    getLiveStartCountdownTime(liveStartCountdown, interval) {
        let newLiveStartCountdown = liveStartCountdown - interval;
        return newLiveStartCountdown < 0 ? 0 : newLiveStartCountdown;
    }
}
//# sourceMappingURL=MasterEventParser.js.map